// AUPRÉA — Intégrations : admin (liste, détail, pièces à contrôler, motifs) + recruteur (Mes recrues)
import { useEffect, useState } from "react";
import axios from "axios";
import { C, Btn, Input, Select, Textarea, Spinner, Alert, fmtEur } from "./shared";
import { API, hdrs, TEAL, OR, ROUGE, fr, errMsg } from "./integrationShared";
import { Frise, FichierLien } from "./Integration";

const ETAPES = [["inscription", "Inscription"], ["validation", "Validation"], ["espace", "Création de l'espace"], ["pieces", "Dépôt des pièces"],
  ["contrats", "Signature des contrats"], ["cotisation", "Cotisation"], ["acces", "Accès"]];
const ZONES = ["Guadeloupe", "Martinique", "Guyane", "La Réunion", "Mayotte", "Saint-Martin", "Saint-Barthélemy", "Hexagone", "Étranger"];

const Modal = ({ title, onClose, children, testid }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.45)", zIndex: 1000, display: "flex", justifyContent: "flex-end" }} onClick={onClose}>
    <div style={{ width: "min(860px, 100%)", background: C.gray2 || "#F7F6F3", height: "100%", overflowY: "auto", padding: 24 }} onClick={e => e.stopPropagation()} data-testid={testid}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: C.navy }}>{title}</div>
        <Btn small onClick={onClose} data-testid={`${testid}-fermer`}>Fermer</Btn>
      </div>
      {children}
    </div>
  </div>
);

const Carte = ({ titre, children }) => (
  <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 18, marginBottom: 14 }}>
    <div style={{ fontSize: 11, fontWeight: 700, color: C.mid, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 10 }}>{titre}</div>
    {children}
  </div>
);

// ── Contrôle d'une pièce (valider / refuser avec motifs) ─────────────────
export const PieceControle = ({ iid, p, motifs, onDone }) => {
  const [refus, setRefus] = useState(false); const [sel, setSel] = useState([]); const [com, setCom] = useState(""); const [err, setErr] = useState("");
  const last = p.versions[p.versions.length - 1];
  const go = async (decision) => {
    setErr("");
    try { await axios.post(`${API}/admin/integrations/${iid}/pieces/${p.type}/controle`, { decision, motifs: sel, commentaire: com }, hdrs()); setRefus(false); setSel([]); setCom(""); onDone(); }
    catch (e) { setErr(errMsg(e)); }
  };
  const col = { a_controler: OR, refusee: ROUGE, validee: TEAL }[p.statut] || C.mid;
  return (
    <div style={{ borderLeft: `3px solid ${col}`, padding: "10px 12px", background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 8 }} data-testid={`ctrl-${iid}-${p.type}`}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: C.navy }}>{p.label}{!p.obligatoire && " (facultative)"}</div>
          <div style={{ fontSize: 11, color: col }}>{{ manquante: "Non déposée", a_controler: "À contrôler", refusee: "Refusée", validee: "Validée" }[p.statut]}</div>
          {last && <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 4 }}>{last.fichiers.map(f => <FichierLien key={f.n} iid={iid} type={p.type} v={last.v} f={f} />)}</div>}
          {p.versions.length > 1 && (
            <details style={{ fontSize: 11, color: C.mid, marginTop: 4 }}><summary>Historique ({p.versions.length} versions)</summary>
              {p.versions.map(v => <div key={v.v} style={{ marginTop: 4 }}>v{v.v} · {fr(v.at)} · {v.statut}{v.motifs ? ` · ${v.motifs.join(", ")}` : ""}{v.commentaire ? ` — ${v.commentaire}` : ""} · {v.fichiers.map(f => <FichierLien key={f.n} iid={iid} type={p.type} v={v.v} f={f} />)}</div>)}
            </details>
          )}
        </div>
        {p.statut === "a_controler" && !refus && (
          <div style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
            <Btn small variant="gold" onClick={() => go("valider")} data-testid={`ctrl-${iid}-${p.type}-valider`}>✓ Valider</Btn>
            <Btn small onClick={() => setRefus(true)} data-testid={`ctrl-${iid}-${p.type}-refuser`}>✗ Refuser</Btn>
          </div>
        )}
      </div>
      {refus && (
        <div style={{ marginTop: 10, background: "#FEF2F2", padding: 10, borderRadius: 8 }} data-testid={`ctrl-${iid}-${p.type}-motifs`}>
          {motifs.map(m => (
            <label key={m} style={{ display: "flex", gap: 6, fontSize: 12, padding: "2px 0", cursor: "pointer" }}>
              <input type="checkbox" checked={sel.includes(m)} onChange={() => setSel(s => s.includes(m) ? s.filter(x => x !== m) : [...s, m])} data-testid={`motif-${m}`} /> {m}
            </label>
          ))}
          <Textarea rows={2} placeholder={sel.includes("Autre") ? "Commentaire (obligatoire pour « Autre »)" : "Commentaire (facultatif)"} value={com} onChange={e => setCom(e.target.value)} data-testid={`ctrl-${iid}-${p.type}-commentaire`} />
          <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
            <Btn small variant="gold" onClick={() => go("refuser")} data-testid={`ctrl-${iid}-${p.type}-confirmer-refus`}>Confirmer le refus</Btn>
            <Btn small onClick={() => setRefus(false)}>Annuler</Btn>
          </div>
        </div>
      )}
      {err && <div style={{ fontSize: 11, color: ROUGE, marginTop: 6 }} data-testid={`ctrl-${iid}-${p.type}-erreur`}>{err}</div>}
    </div>
  );
};

const EtapeManuelle = ({ iid, frise, onDone }) => {
  const [key, setKey] = useState(""); const [com, setCom] = useState(""); const [err, setErr] = useState("");
  const go = async () => {
    try { await axios.post(`${API}/admin/integrations/${iid}/etapes/${key}/manuel`, { commentaire: com }, hdrs()); setKey(""); setCom(""); onDone(); } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <Select value={key} onChange={e => setKey(e.target.value)} data-testid="manuel-etape">
        <option value="">Étape à terminer manuellement…</option>
        {frise.filter(e => e.statut !== "terminee").map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
      </Select>
      <Input placeholder="Commentaire obligatoire" value={com} onChange={e => setCom(e.target.value)} style={{ flex: 1, minWidth: 200 }} data-testid="manuel-commentaire" />
      <Btn small variant="gold" disabled={!key || !com.trim()} onClick={go} data-testid="manuel-valider">Marquer terminée</Btn>
      {err && <span style={{ fontSize: 11, color: ROUGE }}>{err}</span>}
    </div>
  );
};

const DetailIntegration = ({ iid, onClose, onChanged }) => {
  const [d, setD] = useState(null); const [msg, setMsg] = useState("");
  const load = () => axios.get(`${API}/admin/integrations/${iid}`, hdrs()).then(r => setD(r.data));
  useEffect(() => { load(); }, [iid]); // eslint-disable-line react-hooks/exhaustive-deps
  const refresh = () => { load(); onChanged(); };
  const post = async (url, ok) => { try { const r = await axios.post(`${API}${url}`, {}, hdrs()); setMsg(ok(r.data)); refresh(); } catch (e) { setMsg(errMsg(e)); } };
  if (!d) return <Modal title="Intégration" onClose={onClose} testid="integration-detail"><Spinner /></Modal>;
  const contrats = d.frise.find(e => e.key === "contrats"), espace = d.frise.find(e => e.key === "espace");
  return (
    <Modal title={`${d.prenom} ${d.nom}`} onClose={onClose} testid="integration-detail">
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 12 }}>{d.email} · {d.telephone || "—"} · {d.zone} · Recruteur : <strong>{d.parrain_nom}</strong> · Contrat : <strong>{d.type_contrat || "à définir"}</strong></div>
      {msg && <Alert type="info"><span>ℹ</span><span data-testid="integration-detail-msg">{msg}</span></Alert>}
      <Carte titre="Frise"><Frise etapes={d.frise} testid="admin-frise" /></Carte>
      <Carte titre="Pièces">
        <div style={{ display: "grid", gap: 8 }}>{d.pieces.map(p => <PieceControle key={p.type} iid={iid} p={p} motifs={d.motifs_refus} onDone={refresh} />)}</div>
      </Carte>
      <Carte titre="Contrats & paiements">
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", fontSize: 12 }}>
          {contrats.statut === "terminee" ? <span style={{ color: TEAL }} data-testid="detail-contrats-ok">✓ {contrats.sous_titre}</span>
            : <Btn small variant="gold" disabled={!d.conseiller_id} onClick={() => post(`/admin/integrations/${iid}/contrats-signes`, () => "Contrats marqués signés ✓")} data-testid="btn-contrats-signes">☑ Contrats signés</Btn>}
          {espace.statut === "en_cours" && <Btn small onClick={() => post(`/integration/${iid}/renvoyer-lien`, r => r.ok ? "Lien 48 h renvoyé ✓" : `E-mail non parti : ${r.error || r.email_status}`)} data-testid="admin-renvoyer-lien">✉ Renvoyer le lien</Btn>}
        </div>
        <div style={{ marginTop: 10, fontSize: 12 }}>
          {d.paiements.length ? d.paiements.map(p => <div key={p.session_id}>{fr(p.created_at)} · {fmtEur(p.montant_mensuel)}/mois · {p.payment_status}</div>) : <span style={{ color: C.muted }}>Aucun paiement de cotisation.</span>}
        </div>
      </Carte>
      <Carte titre="Terminer une étape manuellement"><EtapeManuelle iid={iid} frise={d.frise} onDone={refresh} /></Carte>
      <Carte titre="Journal">
        <div style={{ maxHeight: 260, overflowY: "auto" }} data-testid="integration-journal">
          {d.journal.map((j, n) => <div key={n} style={{ fontSize: 11.5, padding: "5px 0", borderBottom: `.5px solid ${C.border}` }}>{new Date(j.at).toLocaleString("fr-FR")} · <strong>{j.by}</strong> · {j.detail}</div>)}
        </div>
      </Carte>
    </Modal>
  );
};

const AlerteBadge = ({ a }) => !a?.niveau ? null : (
  <span style={{ background: a.niveau === "rouge" ? "#FEE2E2" : "#FEF3C7", color: a.niveau === "rouge" ? ROUGE : "#B45309", padding: "2px 8px", borderRadius: 999, fontSize: 10, fontWeight: 700 }}
    data-testid="alerte-validation">{a.niveau === "rouge" ? "🔴" : "🟠"} Validation : J+{a.jours_ouvres} ouvrés</span>
);

const LigneDebloquer = ({ x, reload, setMsg }) => {
  const [motif, setMotif] = useState(""); const [ab, setAb] = useState(false);
  const post = async (url, body, ok) => { try { await axios.post(`${API}${url}`, body || {}, hdrs()); setMsg(ok); reload(); } catch (e) { setMsg(errMsg(e)); } };
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", padding: "8px 0", borderBottom: `.5px solid ${C.border}`, fontSize: 12 }} data-testid={`debloquer-${x.id}`}>
      <div><strong style={{ color: C.navy }}>{x.nom}</strong> · {x.etape} depuis {x.jours} j · {x.nb_relances} relance(s) · recruteur {x.parrain_nom}
        {x.pause && <span style={{ marginLeft: 6, background: "#FEE2E2", color: ROUGE, padding: "1px 8px", borderRadius: 999, fontSize: 10, fontWeight: 700 }} data-testid={`pause-${x.id}`}>Intégration en pause</span>}</div>
      <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
        <Btn small variant="gold" onClick={() => post(`/admin/integrations/${x.id}/relancer`, null, `Relance envoyée à ${x.nom} ✓`)} data-testid={`debloquer-relancer-${x.id}`}>🔔 Relancer</Btn>
        {!ab ? <Btn small onClick={() => setAb(true)} data-testid={`debloquer-abandonner-${x.id}`}>Abandonner</Btn> : <>
          <Input placeholder="Motif obligatoire" value={motif} onChange={e => setMotif(e.target.value)} style={{ width: 200 }} data-testid={`abandon-motif-${x.id}`} />
          <Btn small variant="red" disabled={!motif.trim()} onClick={() => post(`/admin/integrations/${x.id}/abandonner`, { motif }, `Intégration de ${x.nom} close`)} data-testid={`abandon-confirmer-${x.id}`}>Confirmer l'abandon</Btn></>}
      </div>
    </div>
  );
};

const ADebloquer = ({ onChanged }) => {
  const [items, setItems] = useState([]); const [msg, setMsg] = useState("");
  const load = () => axios.get(`${API}/admin/integrations-a-debloquer`, hdrs()).then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  if (!items.length && !msg) return null;
  return (
    <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderLeft: `3px solid ${ROUGE}`, borderRadius: 12, padding: 16, marginTop: 18 }} data-testid="integrations-a-debloquer">
      <div style={{ fontWeight: 600, color: C.navy, marginBottom: 6 }}>Intégrations à débloquer ({items.length})</div>
      {msg && <div style={{ fontSize: 12, color: TEAL, marginBottom: 6 }} data-testid="debloquer-msg">{msg}</div>}
      {items.map(x => <LigneDebloquer key={x.id} x={x} setMsg={setMsg} reload={() => { load(); onChanged(); }} />)}
    </div>
  );
};

export const RelancesReglage = () => {
  const [f, setF] = useState(null); const [ok, setOk] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/integration/relances-reglages`, hdrs()).then(r => setF(r.data)); }, []);
  const save = async () => { try { setF((await axios.put(`${API}/admin/integration/relances-reglages`, { ...f, j1: +f.j1, j2: +f.j2, pause: +f.pause }, hdrs())).data); setOk({ t: "Enregistré ✓" }); } catch (e) { setOk({ t: errMsg(e), err: true }); } };
  if (!f) return null;
  return (
    <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 18, marginTop: 16 }} data-testid="reglage-relances">
      <div style={{ fontWeight: 600, color: C.navy, marginBottom: 8 }}>Relances des recrues bloquées</div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 12, alignItems: "center" }}>
        {[["j1", "1re relance (délai avant relance recrue)"], ["j2", "2e relance + « à débloquer »"], ["pause", "Intégration en pause"]].map(([k, l]) => (
          <label key={k} style={{ display: "flex", gap: 6, alignItems: "center" }}>{l} : J+<Input type="number" value={f[k]} onChange={e => setF({ ...f, [k]: e.target.value })} style={{ width: 70 }} data-testid={`relances-${k}`} /></label>))}
      </div>
      <div style={{ fontSize: 11, color: C.mid, margin: "10px 0 4px" }}>Message à la recrue — variables {"{prenom}"} {"{etape}"} {"{lien}"}</div>
      <Textarea rows={3} value={f.texte_recrue} onChange={e => setF({ ...f, texte_recrue: e.target.value })} data-testid="relances-texte-recrue" />
      <div style={{ fontSize: 11, color: C.mid, margin: "10px 0 4px" }}>Notification au recruteur — variables {"{recrue}"} {"{etape}"} {"{jours}"}</div>
      <Textarea rows={2} value={f.texte_recruteur} onChange={e => setF({ ...f, texte_recruteur: e.target.value })} data-testid="relances-texte-recruteur" />
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 8 }}><Btn small variant="gold" onClick={save} data-testid="relances-save">Enregistrer</Btn>
        <span style={{ fontSize: 12, color: ok?.err ? ROUGE : TEAL }} data-testid="relances-msg">{ok?.t}</span></div>
      <div style={{ fontSize: 11, color: C.muted, marginTop: 6 }}>Les étapes où AUPRÉA doit agir (validation, contrôle des pièces, virement) ne relancent jamais la recrue : alerte admin orange à J+3 ouvrés, rouge à J+5.</div>
    </div>
  );
};

export const IntegrationsAdmin = () => {
  const [items, setItems] = useState(null); const [cpt, setCpt] = useState(null); const [f, setF] = useState({ etape: "", recruteur: "", zone: "" }); const [open, setOpen] = useState(null);
  const [recruteurs, setRecruteurs] = useState([]);
  const load = () => {
    const q = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    axios.get(`${API}/admin/integrations?${q}`, hdrs()).then(r => setItems(r.data));
    axios.get(`${API}/admin/integrations/compteurs`, hdrs()).then(r => setCpt(r.data));
  };
  useEffect(() => { load(); }, [f]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    axios.get(`${API}/admin/integrations`, hdrs()).then(r => setRecruteurs([...new Map(r.data.filter(x => x.parrain_id).map(x => [x.parrain_id, x.parrain_nom])).entries()]));
  }, []);
  return (
    <div data-testid="integrations-admin">
      {cpt && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 12, marginBottom: 18 }}>
          {[["Consultants actifs", cpt.actifs, TEAL, "cpt-actifs"], ["En intégration", cpt.en_integration, OR, "cpt-integration"], ["Suspendus", cpt.suspendus, ROUGE, "cpt-suspendus"], ["Validations en retard", cpt.validations_en_retard, "#B45309", "cpt-retard"]].map(([l, v, col, t]) => (
            <div key={t} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderTop: `3px solid ${col}`, borderRadius: 12, padding: 16 }}>
              <div style={{ fontSize: 11, color: C.mid, textTransform: "uppercase", letterSpacing: ".05em" }}>{l}</div>
              <div style={{ fontSize: 28, fontFamily: "'Playfair Display', serif", color: C.navy }} data-testid={t}>{v}</div>
            </div>
          ))}
        </div>
      )}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }} className="aup-filtres">
        <style>{`.aup-filtres > *{width:auto !important;flex:0 1 230px}`}</style>
        <Select value={f.etape} onChange={e => setF({ ...f, etape: e.target.value })} data-testid="filtre-etape"><option value="">Toutes les étapes</option>{ETAPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</Select>
        <Select value={f.recruteur} onChange={e => setF({ ...f, recruteur: e.target.value })} data-testid="filtre-recruteur"><option value="">Tous les recruteurs</option><option value="direct">Direct AUPRÉA</option>{recruteurs.map(([id, n]) => <option key={id} value={id}>{n}</option>)}</Select>
        <Select value={f.zone} onChange={e => setF({ ...f, zone: e.target.value })} data-testid="filtre-zone"><option value="">Toutes les zones</option>{ZONES.map(z => <option key={z}>{z}</option>)}</Select>
      </div>
      {!items ? <Spinner /> : items.length === 0 ? <div style={{ background: "#fff", padding: 40, textAlign: "center", color: C.muted, borderRadius: 12 }}>Aucune intégration en cours</div> : (
        <div style={{ display: "grid", gap: 10 }}>
          {items.map(x => (
            <div key={x.id} onClick={() => setOpen(x.id)} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 14, cursor: "pointer", display: "grid", gridTemplateColumns: "minmax(180px, 1.2fr) 2fr 150px", gap: 16, alignItems: "center" }} data-testid={`integration-row-${x.id}`}>
              <div>
                <div style={{ fontWeight: 600, color: C.navy }}>{x.prenom} {x.nom}</div>
                <div style={{ fontSize: 11, color: C.mid }}>{x.zone} · {x.parrain_nom} · inscrit le {fr(x.created_at)}</div>
                <div style={{ display: "flex", gap: 6, marginTop: 4, flexWrap: "wrap" }}><AlerteBadge a={x.alerte_validation} />{x.pieces_a_controler > 0 && <span style={{ fontSize: 10, background: "#FEF3C7", color: "#B45309", padding: "2px 8px", borderRadius: 999, fontWeight: 700 }}>{x.pieces_a_controler} pièce(s) à contrôler</span>}</div>
              </div>
              <Frise etapes={x.frise} mini testid={`mini-${x.id}`} />
              <div style={{ fontSize: 11, color: C.mid, textAlign: "right" }}>{x.etape_actuelle}<br />{x.jours_etape} j</div>
            </div>
          ))}
        </div>
      )}
      <ADebloquer onChanged={load} />
      {open && <DetailIntegration iid={open} onClose={() => setOpen(null)} onChanged={load} />}
    </div>
  );
};

export const PiecesAControler = () => {
  const [d, setD] = useState(null);
  const load = () => axios.get(`${API}/admin/pieces-a-controler`, hdrs()).then(r => setD(r.data));
  useEffect(() => { load(); }, []);
  if (!d) return <Spinner />;
  return (
    <div data-testid="pieces-a-controler">
      {d.items.length === 0 ? <div style={{ background: "#fff", padding: 40, textAlign: "center", color: C.muted, borderRadius: 12 }} data-testid="pieces-vide">Aucune pièce à contrôler</div> : (
        <div style={{ display: "grid", gap: 10 }}>
          {d.items.map(p => (
            <div key={p.integration_id + p.type}>
              <div style={{ fontSize: 12, color: C.mid, margin: "0 0 4px 2px" }}><strong style={{ color: C.navy }}>{p.recrue}</strong> · recruteur {p.parrain_nom} · déposée le {fr(p.versions[p.versions.length - 1].at)}</div>
              <PieceControle iid={p.integration_id} p={p} motifs={d.motifs} onDone={load} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const MotifsRefusReglage = () => {
  const [txt, setTxt] = useState(null); const [ok, setOk] = useState("");
  useEffect(() => { axios.get(`${API}/admin/integration/motifs`, hdrs()).then(r => setTxt(r.data.motifs.join("\n"))); }, []);
  const save = async () => {
    try { const r = await axios.put(`${API}/admin/integration/motifs`, { motifs: txt.split("\n") }, hdrs()); setTxt(r.data.motifs.join("\n")); setOk("Enregistré ✓"); }
    catch (e) { setOk(errMsg(e)); }
    setTimeout(() => setOk(""), 2500);
  };
  if (txt === null) return <Spinner />;
  const vide = !txt.split("\n").some(m => m.trim() && m.trim() !== "Autre");
  return (
    <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 18, marginTop: 16 }} data-testid="reglage-motifs-refus">
      <div style={{ fontWeight: 600, color: C.navy, marginBottom: 4 }}>Motifs de refus des pièces d'intégration</div>
      <div style={{ fontSize: 11, color: C.mid, marginBottom: 8 }}>Un motif par ligne. « Autre » est toujours proposé (commentaire libre obligatoire).</div>
      <Textarea rows={8} value={txt} onChange={e => setTxt(e.target.value)} data-testid="motifs-textarea" />
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginTop: 8 }}><Btn variant="gold" small disabled={vide} onClick={save} data-testid="motifs-save">Enregistrer</Btn><span style={{ fontSize: 12, color: TEAL }}>{ok}</span></div>
    </div>
  );
};

// ── Recruteur ────────────────────────────────────────────────────────────
const InscrireRecrue = ({ onClose, onDone }) => {
  const [f, setF] = useState({ prenom: "", nom: "", email: "", telephone: "", zone: "Guadeloupe" }); const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true); setErr("");
    try { await axios.post(`${API}/consultants/inviter-recrue`, f, hdrs()); onDone(); onClose(); } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={onClose}>
      <div style={{ background: "#fff", borderRadius: 14, padding: 24, width: "min(480px, 100%)" }} onClick={e => e.stopPropagation()} data-testid="inscrire-recrue-modal">
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, color: C.navy, marginBottom: 12 }}>Inscrire une recrue</div>
        {err && <Alert type="error"><span>⚠</span><span data-testid="inscrire-erreur">{err}</span></Alert>}
        <div style={{ display: "grid", gap: 10 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <Input placeholder="Prénom" value={f.prenom} onChange={e => setF({ ...f, prenom: e.target.value })} data-testid="recrue-prenom" />
            <Input placeholder="Nom" value={f.nom} onChange={e => setF({ ...f, nom: e.target.value })} data-testid="recrue-nom" />
          </div>
          <Input placeholder="E-mail" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} data-testid="recrue-email" />
          <Input placeholder="Téléphone" value={f.telephone} onChange={e => setF({ ...f, telephone: e.target.value })} data-testid="recrue-tel" />
          <Select value={f.zone} onChange={e => setF({ ...f, zone: e.target.value })} data-testid="recrue-zone">{ZONES.map(z => <option key={z}>{z}</option>)}</Select>
          <div style={{ fontSize: 11, color: C.mid }}>Vous êtes enregistré comme recruteur. La demande part en validation AUPRÉA (5 jours ouvrés).</div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Btn onClick={onClose}>Annuler</Btn>
            <Btn variant="gold" disabled={busy || !f.prenom || !f.nom || !f.email} onClick={go} data-testid="recrue-submit">{busy ? "…" : "Inscrire"}</Btn>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MesRecrues = () => {
  const [items, setItems] = useState(null); const [modal, setModal] = useState(false); const [msg, setMsg] = useState("");
  const load = () => axios.get(`${API}/integration/mes-recrues`, hdrs()).then(r => setItems(r.data)).catch(e => setMsg(errMsg(e)));
  useEffect(() => { load(); }, []);
  const renvoyer = async (id) => { try { const r = await axios.post(`${API}/integration/${id}/renvoyer-lien`, {}, hdrs()); setMsg(r.data.ok ? "Lien 48 h renvoyé ✓" : `E-mail non parti : ${r.data.error || r.data.email_status}`); } catch (e) { setMsg(errMsg(e)); } };
  const relancer = async (id) => { try { await axios.post(`${API}/integration/${id}/relancer-recrue`, {}, hdrs()); setMsg("Relance envoyée ✓ (prochaine possible dans 24 h)"); load(); } catch (e) { setMsg(errMsg(e)); } };
  const directes = (items || []).filter(x => x.niveau === 1), autres = (items || []).filter(x => x.niveau > 1);
  return (
    <div data-testid="mes-recrues">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, gap: 10, flexWrap: "wrap" }}>
        <div style={{ fontSize: 13, color: C.mid }}>Suivez l'intégration de vos recrues. Les pièces et contrats restent confidentiels.</div>
        <Btn variant="gold" onClick={() => setModal(true)} data-testid="btn-inscrire-recrue">+ Inscrire une recrue</Btn>
      </div>
      {msg && <Alert type="info"><span>ℹ</span><span data-testid="mes-recrues-msg">{msg}</span></Alert>}
      {!items ? <Spinner /> : (
        <>
          <div style={{ display: "grid", gap: 10 }}>
            {directes.length === 0 && <div style={{ background: "#fff", padding: 30, textAlign: "center", color: C.muted, borderRadius: 12 }}>Aucune recrue en intégration</div>}
            {directes.map(x => (
              <div key={x.id} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 14, display: "grid", gridTemplateColumns: "minmax(160px, 1fr) 2fr 190px", gap: 16, alignItems: "center" }} data-testid={`recrue-row-${x.id}`}>
                <div><div style={{ fontWeight: 600, color: C.navy }}>{x.prenom} {x.nom}</div><div style={{ fontSize: 11, color: C.mid }}>Inscrit le {fr(x.created_at)}</div>
                  {x.frise.find(e => e.key === "contrats")?.sous_titre && <div style={{ fontSize: 11, color: TEAL }} data-testid={`recrue-contrats-${x.id}`}>Contrats signés ✓ {x.frise.find(e => e.key === "contrats").sous_titre.replace("Contrats signés ", "")}</div>}</div>
                <Frise etapes={x.frise} mini testid={`recrue-frise-${x.id}`} />
                <div style={{ fontSize: 11, color: C.mid, textAlign: "right" }}>
                  <div data-testid={`recrue-etape-${x.id}`}>{x.termine ? "✓ Intégration terminée" : `${x.etape_actuelle}${x.etape_statut === "refusee" ? " · à corriger" : ""}`}</div>
                  {!x.termine && <div>{x.jours_etape} j sur cette étape</div>}
                  {x.peut_renvoyer_lien && <Btn small onClick={() => renvoyer(x.id)} data-testid={`recrue-renvoyer-${x.id}`}>✉ Renvoyer le lien</Btn>}
                  {x.peut_relancer && <div style={{ marginTop: 4 }}><Btn small variant="gold" onClick={() => relancer(x.id)} data-testid={`recrue-relancer-${x.id}`}>🔔 Relancer ma recrue</Btn></div>}
                </div>
              </div>
            ))}
          </div>
          {autres.length > 0 && (
            <div style={{ marginTop: 22 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.mid, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 8 }}>Recrues de mes recrues</div>
              <div style={{ display: "grid", gap: 8 }}>
                {autres.map(x => (
                  <div key={x.id} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 10, padding: 12, display: "grid", gridTemplateColumns: "minmax(160px, 1fr) 2fr", gap: 16, alignItems: "center" }} data-testid={`recrue-n${x.niveau}-${x.id}`}>
                    <div style={{ fontSize: 12 }}><strong style={{ color: C.navy }}>{x.prenom} {x.nom}</strong> <span style={{ color: C.muted }}>· N{x.niveau} · via {x.parrain_nom}</span></div>
                    <Frise etapes={x.frise} mini testid={`recrue-frise-${x.id}`} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
      {modal && <InscrireRecrue onClose={() => setModal(false)} onDone={load} />}
    </div>
  );
};
